import classNames from 'classnames';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { MiniBanner } from 'src/components/shared/elements/banners/MiniBanner';
import { KaimonoWebRoutes } from 'src/config/routes';
import { useWindowDimensions } from 'src/hooks/useWindowDimensions';
import { I18nContext } from 'src/stores/I18n';
import { mixpanel } from 'src/utils/mixpanel';

type NaviItem = {
  event: 'coupon-list' | 'ranking' | 'limited_sale' | 'brands' | 'recommended' | 'featured' | 'guide';
  title: string;
  href: string;
};

export const NaviList = () => {
  const localeResources = useContext(I18nContext);
  const { locale } = useRouter();
  const { width } = useWindowDimensions();
  const isPC = width >= 576;

  const naviList: NaviItem[] = [
    {
      event: 'coupon-list',
      title: localeResources.coupons.list.title,
      href: KaimonoWebRoutes.couponList
    },
    {
      event: 'ranking',
      title: localeResources.ranking.popular,
      href: KaimonoWebRoutes.ranking.index
    },
    {
      event: 'limited_sale',
      title: localeResources.featured.limitedSale.title,
      href: KaimonoWebRoutes.featured.limited_sale
    },
    {
      event: 'brands',
      title: localeResources.brands.list.title,
      href: KaimonoWebRoutes.brands.list
    },
    {
      event: 'recommended',
      title: localeResources.recommended.title,
      href: KaimonoWebRoutes.recommended
    },
    {
      event: 'featured',
      title: localeResources.featured.featuredCollections,
      href: KaimonoWebRoutes.featured.index
    },
    {
      event: 'guide',
      title: localeResources.taxFreeGuide.title,
      href: KaimonoWebRoutes.taxfreeGuide
    }
  ];

  return (
    <ul className={classNames('flex flex-col gap-4 list-none', 'semiSm:gap-0')}>
      {naviList.map((item) => (
        <li key={item.title} className={classNames('px-5 py-2', 'semiSm:px-4 semiSm:hover:bg-gray100')}>
          <a
            href={`/kaimono${item.href}`}
            rel="noreferrer noopener"
            onClick={() => {
              mixpanel.onHamburgerMenuClicked(item.event);
            }}
          >
            {item.title}
          </a>
        </li>
      ))}
      <li className={classNames('mx-5 pt-3.5 pb-5 border-b-2 border-solid border-gray200', 'semiSm:mx-4')}>
        <MiniBanner section="hamburgerMenu" />
      </li>
    </ul>
  );
};
